import _get from "lodash/get";
import { Card, Label, List } from "semantic-ui-react";
import { StateIcon } from "../utils";
import { ActionButton } from "../buttons";
import React from "react";
import PropTypes from "prop-types";

export const DatasetSearchItem = ({ result, isDashboard = false }) => {
  const titles = _get(result, "metadata.titles", [{ titleText: "No Title" }]);

  const abstractDescription = _get(result, "metadata.descriptions", [
    { descriptionText: "No Description", descriptionType: "Abstract" },
  ]).find((item) => item.descriptionType === "Abstract") || {
    descriptionText: "No Description",
    descriptionType: "Abstract",
  };

  const keywords = _get(result, "metadata.keywords", []);
  const state = _get(result, "state");

  const creators = _get(result, "metadata.creators", []);
  const formatCreators = ({ creatorsArray }) => {
    if (!creatorsArray || creatorsArray.length === 0) return "--";

    const names = creatorsArray.map((c) => {
      const given = c.creatorGivenName || c.givenName || c.firstName || "";
      const family = c.creatorFamilyName || c.familyName || c.lastName || "";

      const single = c.creatorName || c.name || c.fullName || "";

      if (given || family) {
        return `${given}${given && family ? " " : ""}${family}`.trim();
      }

      if (single) return single;

      return c.id || "Unknown";
    });

    return names.join(", ");
  };

  const creator = formatCreators(creators);

  const temporalCoverages = _get(result, "metadata.temporalCoverages", []);
  const temporalCoverage =
    temporalCoverages.length > 0
      ? formatTemporalCoverage(temporalCoverages)
      : "--";

  function formatTemporalCoverage(data) {
    const startDates = data.map((d) => new Date(d.startDate));
    const endDates = data.map((d) => new Date(d.endDate));

    const earliest = new Date(Math.min(...startDates));
    const latest = new Date(Math.max(...endDates));

    const formatDate = (date) =>
      date.toLocaleString("en-US", { month: "long", year: "numeric" });

    return `${formatDate(earliest)}-${formatDate(latest)}`;
  }

  const getTitle = () => {
    const firstTitle =
      titles && titles.length > 0
        ? titles[0]
        : { titleText: "[NO TITLE - PLEASE FILL THE TITLE]" };
    const title = firstTitle.titleText
      ? firstTitle.titleText
      : "[NO TITLE - PLEASE FILL THE TITLE]";

    return (
      <Card.Header style={{ marginTop: "1.2rem", fontSize: "1.5rem" }}>
        {title}
      </Card.Header>
    );
  };

  const getKeywords = () => {
    return keywords.length > 0 ? (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
        {keywords.map((keyword, i) => (
          <Label
            as="a"
            href={`?q=&f=metadata_keywords_keywordLabel:${keyword.keywordLabel}`}
            key={i}
            basic
            color="blue"
            className="search-keyword-label"
          >
            {keyword.keywordLabel}
          </Label>
        ))}
      </div>
    ) : (
      <span>No keywords available</span>
    );
  };

  const getCleanDescription = () => {
    const abstractDescriptionText = abstractDescription.descriptionText;
    const cleanDescription = abstractDescriptionText
      ? abstractDescriptionText.replace(/<\/?[^>]+(>|$)/g, "")
      : "";
    return (
      <Card.Description style={{ marginTop: "2rem" }}>
        {cleanDescription}
      </Card.Description>
    );
  };

  return (
    <Card
      key={result.id}
      href={result.links.self_html}
      data-testid="dashboardAssetListItem"
      fluid
      className="search-listing-item"
    >
      <Card.Content>
        {isDashboard && <StateIcon state={state} />}
        {getTitle()}
        <Card.Meta style={{ marginTop: "1rem" }}>
          <List>
            <List.Item>
              <List.Icon color="orange" name="user outline" />
              <List.Content>{creator}</List.Content>
            </List.Item>
            <List.Item>
              <List.Icon color="orange" name="calendar outline" />
              <List.Content>{temporalCoverage}</List.Content>
            </List.Item>
          </List>
        </Card.Meta>

        {getCleanDescription()}
      </Card.Content>
      <Card.Content extra>{getKeywords()}</Card.Content>
      {isDashboard && (
        <Card.Content extra textAlign="right">
          <ActionButton
            disabled={["published"].includes(state)}
            record={result}
          />
        </Card.Content>
      )}
    </Card>
  );
};

DatasetSearchItem.propTypes = {
  result: PropTypes.object.isRequired,
  isDashboard: PropTypes.bool,
};
